export default {
    dependencies: ['$element', 'favoritesservice'],
    callable(ele, favoritesService) {
        const listId = ele.getAttribute('data-favorite-list-id');
        const listTitle = ele.getAttribute('data-favorite-list-delete-title');
        ele.addEventListener('click', handleClick, true);

        function handleClick() {
            // eslint-disable-next-line no-alert
            const shouldDelete = window.confirm(
                `Er du sikker på at du vil slette lista «${listTitle}»?`
            );
            if (shouldDelete) {
                favoritesService.deleteList(listId).then(() => {
                    window.location = '/user/favorite/lists.html';
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoritesDeleteList.js